export default __webpack_public_path__ + "static/media/instagram.72350b53.svg";